import React from 'react';
import classNames from 'classnames';
import './styles.css';

const Arc = ({ className, children }) => {
  return (
    <div
      className={classNames('Landing__Background__Arc', {
        [className]: className,
      })}
    >
      {children}
    </div>
  );
};

export default Arc;
